<script lang="ts">
	import type { MuxVideoData } from '@tools/cms';
	import { fade } from 'svelte/transition';

	let {
		video,
		lazy = true,
		isLoaded = $bindable(false)
	}: { video: MuxVideoData; lazy?: boolean; isLoaded?: boolean } = $props();
</script>

<div class="asset" class:ready={isLoaded} data-component="DatoVideo">
	{#if !isLoaded}
		<img
			transition:fade={{
				delay: 100,
				duration: 400
			}}
			src={`https://image.mux.com/${video.muxPlaybackId}/thumbnail.webp?width=${video.width * 0.3}&time=0.2`}
			alt={'Indlæser video...'}
			loading={lazy ? 'lazy' : 'eager'}
		/>
	{/if}
	<mux-video
		tabindex="-1"
		loading={lazy ? 'viewport' : 'page'}
		muted={true}
		autoplay={true}
		loop={true}
		disable-tracking={true}
		playsinline={true}
		disablepictureinpicture={true}
		disableremoteplayback={true}
		playback-id={video.muxPlaybackId}
		style={{ aspectRatio: video.width / video.height }}
		onloadeddata={() => {
			isLoaded = true;
		}}
	></mux-video>
</div>

<style lang="scss">
	div {
		position: relative;
		overflow: hidden;
		height: 100%;
		width: 100%;
		object-fit: cover;
		z-index: 1;
	}

	img {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
		z-index: 10;
	}

	mux-video {
		width: 100%;
		height: 100%;
		opacity: 0;
		transition: opacity 0.4s ease-out;
		--media-object-fit: cover;
	}

	.ready mux-video {
		opacity: 1;
	}
</style>
